export default {
  online_payments_off:
    'La consegna è attiva, ma i clienti non possono ordinarla: la consegna con corriere si paga solo online e i pagamenti online sono disattivati.',
  gateway_not_verified:
    'La consegna è attiva, ma i clienti non possono ordinarla: la consegna con corriere si paga solo online e i pagamenti online sono sospesi finché il tuo account di pagamento non viene verificato.',
  stripe_processing_fee_missing:
    'La consegna è attiva, ma i clienti non possono ordinarla: la consegna con corriere si paga solo online e i pagamenti online sono in pausa finché il tuo partner non imposta la commissione di elaborazione.',
  turn_on_online_payments: 'Attiva i pagamenti online',
};
